// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"4f727b5f","125":"9161106b","181":"3f0e16c9","206":"21b14388","405":"59764425","453":"ce9f93da"}[chunkId] + ".chunk.js";
};